import { Card } from '@nextui-org/react'
import { SliceTooltipProps } from '@nivo/line'
import { FC } from 'react'

export type PlotTooltipProps = {
  item: SliceTooltipProps
  labels: number[]
}

export const HistTooltip: FC<PlotTooltipProps> = ({ item, labels }) => {
  return (
    <Card className="w-[25dvh] h-fill">
      {item.slice.points.map((value) => {
        const targetIndex = value.index % (labels.length - 1)
        return (
          <div key={value.id} className="flex flex-row items-start justify-between gap-2 p-2">
            <div className="mt-[2px]">
              <svg width="10" height="10" aria-hidden="true">
                <rect width="10" height="10" fill={value.color} />
              </svg>
            </div>
            <div className="flex-1 text-left text-xs">
              <div>Tank: {String(value.serieId)}</div>
              <div>Range: {`${labels[targetIndex]} ~ ${labels[targetIndex + 1]}`}</div>
              <div>Value: {String(value.data.y)} %</div>
            </div>
          </div>
        )
      })}
    </Card>
  )
}
